export default function ConfirmModal({ open, title, message, onConfirm, onCancel, confirmText = 'Confirmar', cancelText = 'Cancelar', type = 'danger' }) {
  if (!open) return null

  const typeStyles = {
    danger: 'bg-red-600/90 hover:bg-red-500',
    warning: 'bg-amber-500/90 hover:bg-amber-400',
    info: 'bg-blue-600/90 hover:bg-blue-500',
    success: 'bg-emerald-600/90 hover:bg-emerald-500'
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative z-10 mx-4 w-full max-w-sm rounded-2xl bg-brand-900 p-6 shadow-2xl border border-white/10">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white/10">
            {type === 'danger' && <span className="text-2xl">⚠️</span>}
            {type === 'warning' && <span className="text-2xl">⚡</span>}
            {type === 'info' && <span className="text-2xl">ℹ️</span>}
            {type === 'success' && <span className="text-2xl">✅</span>}
          </div>
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <p className="mt-2 text-sm text-white/70">{message}</p>
        </div>
        <div className="mt-6 flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 rounded-xl bg-white/10 px-4 py-3 text-sm font-semibold text-white hover:bg-white/20 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 rounded-xl px-4 py-3 text-sm font-semibold text-white transition-colors ${typeStyles[type]}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
